import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Site } from 'src/app/admin/1.tv/sites/sites.model';

@Component({
  selector: 'app-get-in-touch',
  templateUrl: './get-in-touch.component.html',
  styleUrls: ['./get-in-touch.component.scss']
})
export class GetInTouchComponent implements OnInit {
  @Input() sites$: Observable<Site[]>;
  constructor() { }

  ngOnInit() {
  }

}
